import { useQuery } from '@tanstack/react-query'

type Config = {
    CLARITY_ID: string
    SLEEK_PRODUCT_ID: string
    features: Record<string, boolean>
}

export const useGetConfig = () => useQuery<Config>({ queryKey: ['config'] })
